import styled from "styled-components";

export const ViewTitle = styled.h1`
  margin: 0;
  max-height: 10vh;
  font-size: 4vh;
  line-height: 10vh;
`;